export const manifest = {
  screens: {
    scr_qf39sy: { name: "Review Form", route: "/", position: {"x":160,"y":220} },
    scr_cs9r3e: { name: "Success Screen", route: "/", state: {"submitted":true}, position: {"x":1560,"y":220} },
  },
  sections: {
    sec_ufpbh6: { name: "Form Submission", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ufpbh6", children: [
      { kind: "screen", id: "scr_qf39sy" },
      { kind: "screen", id: "scr_cs9r3e" },
    ] },
  ],
}
